import { DatePipe } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-device-swap-modal',
  templateUrl: './device-swap-modal.component.html',
  styleUrls: ['./device-swap-modal.component.css']
})
export class DeviceSwapModalComponent implements OnInit, OnDestroy {

  deviceSwapForm: FormGroup;
  userSubmit: boolean = false;
  deviceList: any = [];
  isDeallocated: boolean = false;
  deviceDetails: any;
  condition: any;
  private _getEntityDetailsSubscription: Subscription;
  private _availableDevicesSubscription: Subscription;
  private _entityDeviceAllocationSubscription: Subscription;
  private _entityDeviceDeallocationSubscription: Subscription;

  constructor(private _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _datePipe: DatePipe,
    private _dataSer: DataService) {

  }

  ngOnInit(): void {
    this._initiazileForm(this.data);
    this._getBatteryCondition();
  }
  ngOnDestroy(): void {
    this._getEntityDetailsSubscription?.unsubscribe();
    this._availableDevicesSubscription?.unsubscribe();  
    this._entityDeviceAllocationSubscription?.unsubscribe();  
    this._entityDeviceDeallocationSubscription?.unsubscribe();  

  }
  closeModal() {
    this._dialogRef.close(true);
  }

  onSubmit() {
    this.userSubmit = true;
    if (this.deviceSwapForm.invalid && this.userSubmit) {
      return;
    }
    else {
      this.isDeallocated ? this._allocateDevice() : this._deAllocateDevice();
    }
  }
  private _initiazileForm(details: any) {
    const deviceData = details?.deviceDetails;
    this.deviceSwapForm = this._fb.group({
      device: ['', [Validators.required]],
      patientName: [deviceData ? deviceData?.entityName : '', [Validators.required]]
    });
    this._getEntitiesDetails();
  }

  private _getEntitiesDetails() {
    const entityId = { entityId: this.data?.deviceDetails?.entityId };
    this._getEntityDetailsSubscription = this._service.getEntityDetails(entityId).subscribe((result: any) => {
      if (result.status) {
        this.deviceDetails = result?.response?.data[0];
        this.deviceSwapForm.controls['patientName'].disable();
        if (this.deviceDetails?.device?._id) {
          this.deviceList = [{ _id: this.deviceDetails?.device?._id, deviceName: this.deviceDetails?.device?.deviceName }];
          this.deviceSwapForm.patchValue({
            device: this.deviceDetails?.device?._id
          });
          this.deviceSwapForm.controls['device'].disable();
        } else {
          this.isDeallocated = true;
          this._availableDevices();
        }
      } else {
        this._service.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  private _getBatteryCondition() {
    if (+this.data?.deviceDetails?.Battery > 50) {
      this.condition = "Charged";
    } else if (50 >= +this.data?.deviceDetails?.Battery && +this.data?.deviceDetails?.Battery > 20) {
      this.condition = "To be Charged";
    } else {
      this.condition = "Low battery";
    }
  }

  get deviceSwapFormValues() {
    return this.deviceSwapForm.controls;
  }

  private _availableDevices() {
    const reqData = {
      entityId: this.data?.deviceDetails?.entityId,
      siteId: this.deviceDetails?.site?._id
    }
    this._availableDevicesSubscription = this._service.availableDevices(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response'] && result['response']['data']?.length) {
          this.deviceList = result['response']['data'];
        } else {
          this.deviceList = [];
        }
      } else {
        this.deviceList = [];
        this._service.toasterService({ type: 'error', msg: result["response"]["message"] });
      }
    });
  }

  private _allocateDevice() {
    const attributeList = this._service.getConfiguration('vehicleAttributes', 'object');
    if (attributeList && Object.keys(attributeList)?.length) {
      const entityDeviceAllocationPayload = {
        siteId: this.deviceDetails?.site?._id,
        deviceId: this.deviceSwapForm.controls['device'].value,
        deviceType: null,
        currentTime: this._datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ssZ'),
        entityId: this.data?.deviceDetails?.entityId,
        attribute: attributeList.values.attributes
      }
      this._entityDeviceAllocationSubscription = this._service.entityDeviceAllocation(entityDeviceAllocationPayload).subscribe((response: any) => {
        this._service.toasterService({ type: response['status'] ? 'success' : 'error', msg: response?.response?.message });
        if (response['status']) {
          this.userSubmit = false;
          this._dialogRef.close(true);
          this._dataSer.broadcast('deviceMapRefresh');
        }
      });
    } else {
      this._service.toasterService({ type: 'warning', msg: 'vehicleAttributes configuration not available' });
    }
  }

  private _deAllocateDevice() {
    const entityDeviceDeallocationPayload = {
      siteId: this.deviceDetails?.site?._id,
      deviceId: this.deviceDetails?.device?._id,
      deviceType: null,
      currentTime: this._datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ssZ'),
      entityId: this.data?.deviceDetails?.entityId
    }
    this._entityDeviceDeallocationSubscription = this._service.entityDeviceDeallocation(entityDeviceDeallocationPayload).subscribe((response: any) => {
      this._service.toasterService({ type: response['status'] ? 'success' : 'error', msg: response?.response?.message });
      if (response['status']) {
        this.userSubmit = false;
        this.isDeallocated = true;
        this.deviceSwapForm.controls['device'].enable();
        this.deviceSwapForm.controls['device'].reset();
        this._availableDevices();
        this._dataSer.broadcast('deviceMapRefresh');
      }
    });
  }

}
